import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioBox as CoreRadioBox } from '@vds-core/radio-boxes';
import { BodyConfig, TypographyConfig } from '@vds/typography';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors, calculateSpacing } from '@vds/theme';
var typescale = TypographyConfig.getTypescale();
var minHeight = calculateRem(44);
var innerPadding = calculateSpacing('3X');

function _calcTypography(typescale, stacked, component) {
  return BodyConfig.getStyles(typescale, 'desktop', 'small');
}

var propTypes = {
  /**
   * If provided, the RadioBox will be set to show as out of stock
   */
  outOfStock: PropTypes.bool
};
var defaultProps = {
  outOfStock: false
};

var RadioBox = function RadioBox(props) {
  var orientation = props.orientation,
      outOfStock = props.outOfStock;
  return /*#__PURE__*/React.createElement(CoreRadioBox, _extends({}, props, {
    minHeight: minHeight,
    padding: innerPadding,
    typescale: typescale,
    calcTypography: _calcTypography,
    colorConfig: colors,
    backgroundColor: colors.white,
    borderColor: colors.coolGray6,
    labelMargin: false,
    outOfStock: outOfStock,
    hoverState: true,
    disabledState: true,
    activeState: true,
    focusState: true
  }));
};

export default RadioBox;